export const isScrollbarAvailable = (): boolean => {
    try {
        const root =
            document.compatMode === 'BackCompat' ? document.body : document.documentElement;
        return root.scrollHeight > root.clientHeight;
    } catch {
        return false;
    }
};
